export enum MultiInputType {
  Default = 'Default',
  InputSelect = 'InputSelect',
}
